import React from "react";
import "../Styles/NotFound.css"; // Make sure the CSS file includes the animation styles
import { Link } from "react-router-dom";
import { FcSearch } from "react-icons/fc";

const NotFound = () => {
  return (
    <div className="not-found-container page-shell">
      <div
        className="not-found-content"
        data-aos="zoom-in"
        data-aos-duration="700"
      >
        <span style={{ fontSize: "100px" }} className="animated-icon">
          <FcSearch />
        </span>
        <h1>404</h1>
        <b className="fs-4 text-danger">Data Not Found</b>
        <br />  
        <p>Oops! The page you are looking for doesn't exist.</p>
        <Link to="/">
          <button className="go-home-button">Go to Home</button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
